function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 8c6.075 0 11 4.925 11 11 0 2.005-.536 3.882-1.471 5.5a1 1 0 101.731 1A12.945 12.945 0 0029 19c0-7.18-5.82-13-13-13-2.82 0-5.429.897-7.559 2.422L9.84 9.886A10.949 10.949 0 0116 8zM5.953 14.514L4.27 13.392A12.95 12.95 0 003 19c0 2.366.633 4.588 1.74 6.5a1 1 0 001.731-1A10.945 10.945 0 015 19c0-1.598.34-3.116.953-4.486zM5.258 8.466a.3.3 0 01.447-.014l5.835 6.114a.3.3 0 01.013.4l-.298.355a.3.3 0 01-.396.056l-7.035-4.684a.3.3 0 01-.063-.442l1.497-1.785z",
  fill: "currentColor"
})));